import React from "react";

export function BufferOverflowPractice() {
  return (
    <div style={{ marginBottom: "1.5rem" }}>
      <h3>🔐 Buffer Overflow Practice</h3>
      <p>
        Explore vulnerable C programs and exploit buffer overflows. Includes downloadable source code and walkthrough.
      </p>
      <a href="/labs/ethicalhacking/Buffer Overflow Practice/BUFFER OVERFLOW PRACTICE.docx" download>
  📄 Download BUFFER OVERFLOW PRACTICE.docx
</a>

    </div>
  );
}

export function CAndGDBPractice() {
  return (
    <div style={{ marginBottom: "1.5rem" }}>
      <h3>⚙️ C and GDB Practice</h3>
      <p>
        Practice debugging C programs using GDB. Learn to trace stack frames and identify vulnerabilities.
      </p>
      <a href="/labs/ethicalhacking/C and GDB Practice/lab.zip" download>
        📁 Download Lab Files (ZIP)
      </a>
    </div>
  );
}

export function DNSSetupAndPortScan() {
  return (
    <div style={{ marginBottom: "1.5rem" }}>
      <h3>🌐 DNS Setup and Port Scan</h3>
      <p>
        Configure DNS servers and scan open ports using Nmap. Includes config files and PCAP samples.
      </p>
      <a href="/labs/ethicalhacking/DNS Setup and Port Scan/lab.zip" download>
        📁 Download Lab Files (ZIP)
      </a>
    </div>
  );
}

export function LinuxBasics() {
  return (
    <div style={{ marginBottom: "1.5rem" }}>
      <h3>🐧 Linux Basics</h3>
      <p>
        Learn file system navigation, user permissions, and basic commands. Includes shell script samples.
      </p>
      <a href="/labs/ethicalhacking/Linux Basics/lab.zip" download>
        📁 Download Lab Files (ZIP)
      </a>
    </div>
  );
}

export function ManipulatingStacks() {
  return (
    <div style={{ marginBottom: "1.5rem" }}>
      <h3>📦 Manipulating Stacks</h3>
      <p>
        Visualize and manipulate the program stack during execution. Analyze function calls and stack layout.
      </p>
      <a href="/labs/ethicalhacking/Manipulating Stacks/lab.zip" download>
        📁 Download Lab Files (ZIP)
      </a>
    </div>
  );
}

export function MetasploitPractice() {
  return (
    <div style={{ marginBottom: "1.5rem" }}>
      <h3>💥 Metasploit Practice</h3>
      <p>
        Perform exploitation with Metasploit modules against test environments. Includes step-by-step guide.
      </p>
      <a href="/labs/ethicalhacking/Metasploit Practice/lab.zip" download>
        📁 Download Lab Files (ZIP)
      </a>
    </div>
  );
}

export function WebAppSecurityAndRuby() {
  return (
    <div style={{ marginBottom: "1.5rem" }}>
      <h3>🌐 Web App Security and Ruby</h3>
      <p>
        Secure Ruby-based web applications by analyzing routing, controllers, and input handling.
      </p>
      <a href="/labs/ethicalhacking/Web App Security and Ruby/lab.zip" download>
        📁 Download Lab Files (ZIP)
      </a>
    </div>
  );
}

export function X86Assembly() {
  return (
    <div style={{ marginBottom: "1.5rem" }}>
      <h3>💻 x86 Assembly</h3>
      <p>
        Disassemble and analyze x86 binaries. Understand registers, flags, and instructions.
      </p>
      <a href="/labs/ethicalhacking/x86 Assembly/lab.zip" download>
        📁 Download Lab Files (ZIP)
      </a>
    </div>
  );
}
